import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { postSapIbpSyncStatus } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchSapIbpSyncStatus = createApi(postSapIbpSyncStatus, "POST");

const sapIbpSyncStatusSlice = createSlice({
  name: "sapIbpSyncStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSapIbpSyncStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSapIbpSyncStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSapIbpSyncStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default sapIbpSyncStatusSlice.reducer;
